var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckAmber = function SvgIconCheckAmber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.612305C14.9706 0.612305 19 4.64174 19 9.6123C19 14.5829 14.9706 18.6123 10 18.6123C5.02944 18.6123 1 14.5829 1 9.6123C1 4.64174 5.02944 0.612305 10 0.612305ZM15.2695 5.84668C14.9627 5.53447 14.466 5.53451 14.1592 5.84668L8.42871 11.6807L5.84082 9.04688C5.53398 8.73458 5.03728 8.73453 4.73047 9.04688C4.42363 9.35929 4.42363 9.86531 4.73047 10.1777L7.87305 13.3779C8.17989 13.6903 8.67753 13.6903 8.98438 13.3779L15.2695 6.97754C15.5763 6.66511 15.5764 6.15908 15.2695 5.84668Z",
    fill: "#F49015"
  })));
};
export default SvgIconCheckAmber;